/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {RootCategoriesInner} from './RootCategoriesInner';

/**
 * The RootCategories model module.
 * @module model/RootCategories
 * @version v1
 */
export class RootCategories extends Array {
  /**
   * Constructs a new <code>RootCategories</code>.
   * @alias module:model/RootCategories
   * @class
   * @extends Array
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>RootCategories</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RootCategories} obj Optional instance to populate.
   * @return {module:model/RootCategories} The populated <code>RootCategories</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RootCategories();
      ApiClient.constructFromObject(data, obj, 'RootCategoriesInner');
    }
    return obj;
  }
}
